/* Status pill. Tones are functional: mint = connected, amber = ringing,
   red = missed. Don't repurpose them for decoration. */
export default function Pill({ tone = 'offline', children }) {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}
